import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const EmojiIcon = (props: IconProps) => (
  <Icon width="24px" height="24px" viewBox="0 0 24 24" {...props}>
    <path d="M16.0674 11c.8284 0 1.5-.6716 1.5-1.5 0-.82843-.6716-1.5-1.5-1.5s-1.5.67157-1.5 1.5c0 .8284.6716 1.5 1.5 1.5Zm-7.00002 0c.82843 0 1.50002-.6716 1.50002-1.5 0-.82843-.67159-1.5-1.50002-1.5-.82842 0-1.5.67157-1.5 1.5 0 .8284.67158 1.5 1.5 1.5Z" />
    <path d="M16.0674 11c.8284 0 1.5-.6716 1.5-1.5 0-.82843-.6716-1.5-1.5-1.5s-1.5.67157-1.5 1.5c0 .8284.6716 1.5 1.5 1.5Zm-7.00002 0c.82843 0 1.50002-.6716 1.50002-1.5 0-.82843-.67159-1.5-1.50002-1.5-.82842 0-1.5.67157-1.5 1.5 0 .8284.67158 1.5 1.5 1.5Z" />
    <path d="M12.5574 2C7.03738 2 2.56738 6.48 2.56738 12s4.47 10 9.99002 10c5.53 0 10.01-4.48 10.01-10s-4.48-10-10.01-10Zm.01 18c-4.42002 0-8.00002-3.58-8.00002-8s3.58-8 8.00002-8c4.42 0 8 3.58 8 8s-3.58 8-8 8Zm0-2.5c2.33 0 4.32-1.45 5.12-3.5h-1.67c-.69 1.19-1.97 2-3.45 2-1.48 0-2.75002-.81-3.45002-2h-1.67c.8 2.05 2.79002 3.5 5.12002 3.5Z" />
  </Icon>
);

export default memo(EmojiIcon);
